import { Navigate } from 'react-router-dom';

import { useAuth } from '../providers/AuthProvider';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const PublicRoute = ({ children }: ProtectedRouteProps) => {
  const { hasUser } = useAuth();

  if (hasUser) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};
